import ButtonGroup from "../partials/ButtonGroup";
import {SbBlokData, storyblokEditable} from "@storyblok/react";

interface IProps {
    blok: { title: string, subtitle: string, background: string, buttons: Array<any>, text_color1: string, text_color2: string } & SbBlokData
}

export default function SimpleCTA(props: IProps) {
    const blok = props.blok;
    const buttons = <ButtonGroup buttons={blok.buttons || []}/>


    const styles: { [key: string]: string; } = {
        'style1': 'bg-gradient-to-r from-gray-100 via-gray-200 to-gray-50 border',
        'style2': 'bg-gradient-to-tl from-red-400/10 via-gray-300/10 to-blue-500/10',
        'style3': 'bg-gradient-to-r from-yellow-50 to-yellow-300',
        'style4': 'bg-gradient-to-b from-secondary/30 to-secondary/20'
    }

    const backgroundClass = styles[blok.background] ?? blok.background ?? 'bg-primary';

    return (
        <div className={"bg-white " + blok.container_class} {...storyblokEditable(blok)}>

            <div
                data-aos={'fade-in'}
                className={"mx-auto max-w-7xl px-6 py-8 sm:py-12 lg:flex lg:items-center lg:justify-between"}>

                <div
                    className={(backgroundClass || 'bg-primary') + " rounded-xl shadow-lg py-10 px-12 w-full lg:flex lg:items-center " + ((blok.buttons.length > 0) ? 'lg:justify-between' : '')}>
                    <p className={blok.text_color1 + " text-3xl font-bold tracking-tight sm:text-4xl"}>
                        {blok.title}
                        <br/>
                        <span className={blok.text_color2 + " text-2xl"}>{blok.subtitle}</span>
                    </p>
                    {blok.buttons?.length > 0 &&
                    <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
                        {buttons}
                    </div>
                    }
                </div>

            </div>

        </div>
    )
}
